import React, { useState } from "react";
import {
  buildCredentialExpiryWarningMessage,
  dismissCredentialExpiryBannerForSession,
  isCredentialExpiryBannerDismissed,
} from "../../../utils/credentialGateUtils";
import "./CredentialExpiryWarningBanner.scss";

const CredentialExpiryWarningBanner = ({ userData, onChangeCredentials }) => {
  const message = buildCredentialExpiryWarningMessage(userData);
  const [dismissed, setDismissed] = useState(() =>
    isCredentialExpiryBannerDismissed(),
  );

  if (!message || dismissed) return null;

  const handleDismiss = () => {
    dismissCredentialExpiryBannerForSession();
    setDismissed(true);
  };

  return (
    <div className="credential-expiry-banner" role="status">
      <div className="credential-expiry-banner__content">
        <i
          className="fas fa-exclamation-triangle credential-expiry-banner__icon"
          aria-hidden="true"
        />
        <p className="credential-expiry-banner__text mb-0">{message}</p>
      </div>
      <div className="credential-expiry-banner__actions">
        <button
          type="button"
          className="btn btn-sm btn-warning credential-expiry-banner__action"
          onClick={onChangeCredentials}
        >
          Change credentials
        </button>
        <button
          type="button"
          className="credential-expiry-banner__dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss for this session"
          title="Dismiss for this session"
        >
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default CredentialExpiryWarningBanner;
